import { Route } from '@angular/router';
import { customerAuthGuard, tenantMembershipGuard } from '@pryspace/shared/guards';

export const appRoutes: Route[] = [
  { path: '', redirectTo: 'app/home', pathMatch: 'full' },
  // Public auth routes
  {
    path: 'login',
    loadComponent: () =>
      import('@pryspace/pryspace/auth/feature-login').then((m) => m.LoginComponent),
  },
  {
    path: 'handoff/:code',
    loadComponent: () =>
      import('@pryspace/pryspace/auth/feature-handoff').then((m) => m.HandoffComponent),
  },
  {
    path: 'register',
    loadComponent: () =>
      import('@pryspace/pryspace/auth/feature-register').then((m) => m.RegisterComponent),
  },
  {
    path: 'verify-email',
    loadComponent: () =>
      import('@pryspace/pryspace/auth/feature-verify-email').then((m) => m.VerifyEmailComponent),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('@pryspace/pryspace/auth/feature-forgot-password').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('@pryspace/pryspace/auth/feature-reset-password').then(
        (m) => m.ResetPasswordComponent,
      ),
  },
  // Customer/member zone and contextual tenant workspaces live under one
  // authenticated `/app/*` tree, matching the PryZone workflow.
  {
    path: 'app',
    loadChildren: () => import('@pryspace/pryspace/shell').then((m) => m.customerRoutes),
    canActivate: [customerAuthGuard],
  },

  // Compatibility for bookmarks created before the `/app/*` workflow. New
  // navigation always uses `/app/tenants/:slug/...`.
  {
    path: 'tenants/:slug',
    loadChildren: () =>
      import('@pryspace/pryspace/tenant/shell').then((m) => m.tenantRoutes),
    canActivate: [tenantMembershipGuard],
  },

  // Backwards-compatible aliases from the first MVP shell.
  { path: 'account', redirectTo: 'app/account', pathMatch: 'full' },
  { path: 'home', redirectTo: 'app/home', pathMatch: 'full' },

  // Back-compat: the old singular path used pre-migration. Redirect rather
  // than 404 anything that still has the old URL bookmarked.
  { path: 'tenant/:slug', redirectTo: 'tenants/:slug' },

  { path: '**', redirectTo: 'app/home' },
];
